import { DataSource, Label, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSettlementMessages extends Layout {
    labelDescription: Label;
    sourceSettlementNotes: DataSource;
    textboxCompanyDrNote: Textbox;
    textboxCompanyEndDate: Textbox;
    textboxOwnerDrNote: Textbox;
    textboxOwnerEndDate: Textbox;
}
